import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
import { isNotDecimalNumber } from "../../Util/Util/validations.js";
const HouseNumber = ({
  label,
  errorMessage,
  validations = [isNotDecimalNumber],
  ...rest
}) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "streetNumber",
    "data-t": "house-number",
    type: "text",
    label,
    errorMessage,
    validations,
    ...rest
  }
);
export {
  HouseNumber as default
};
//# sourceMappingURL=HouseNumber.js.map
